import type { AnyAction, Middleware } from 'redux';
import { getAuthUserId } from '../../selectors/auth';
import { getUserInterfaceConfig, isConversionModalOpen } from '../../selectors/trainer';
import { DOMAIN_CALL_ENDED, DOMAIN_CALL_STARTED } from '../../actions/actionTypes/domain';
import { HIDE_CONVERSION_MODAL, SHOW_CONVERSION_MODAL } from '../../actions/actionTypes/conversion';
import { SAVE_CONVERSION } from '../../actions/actionTypes/trainer';
import { CONVERSION_RESULT } from '../../../components/Trainer/Conversion/TrainerConversion';
import { DISPLAY_CONVERSION_MODAL, isFeatureEnabled } from '../../../config/features';

const SHORT_CALL_DURATION_SECONDS = 20;

function getCallDuration(payload: unknown): number {
    if (typeof payload === 'object' && payload !== null && 'callDuration' in payload) {
        const value = (payload as { callDuration?: unknown }).callDuration;
        return typeof value === 'number' ? value : 0;
    }
    return 0;
}

const conversionMiddleware: Middleware = store => next => (action: AnyAction) => {
    const { type } = action;

    switch (type) {
        case DOMAIN_CALL_ENDED: {
            const state = store.getState();
            if (isFeatureEnabled(getUserInterfaceConfig(state), DISPLAY_CONVERSION_MODAL)) {
                if (getCallDuration(action.payload) > SHORT_CALL_DURATION_SECONDS) {
                    store.dispatch({
                        type: SHOW_CONVERSION_MODAL
                    });
                } else {
                    setTimeout(
                        () =>
                            store.dispatch({
                                type: SAVE_CONVERSION,
                                payload: {
                                    conversionResult: CONVERSION_RESULT.SHORT_CALL,
                                    userId: String(getAuthUserId(state)),
                                    callId: state.trainer.callId
                                }
                            }),
                        250
                    ); // a short pause for the call to get into the database
                }
            }
            break;
        }
        case DOMAIN_CALL_STARTED: {
            const state = store.getState();
            if (isFeatureEnabled(getUserInterfaceConfig(state), DISPLAY_CONVERSION_MODAL)) {
                if (isConversionModalOpen(state)) {
                    store.dispatch({
                        type: SAVE_CONVERSION,
                        payload: {
                            conversionResult: CONVERSION_RESULT.OVERWRITTEN,
                            userId: String(getAuthUserId(state)),
                            callId: state.trainer.callId
                        }
                    });
                }
                store.dispatch({
                    type: HIDE_CONVERSION_MODAL
                });
            }
            break;
        }

        default:
    }

    return next(action);
};

export default conversionMiddleware;
